import {
    InfoPresentersRegister as InfoPresentersRegisterApi,
    infoPresentersRegister as infoPresentersRegisterApi
} from '../../src/utils/api/InfoPresentersRegister'

export type InfoPresentersRegister = InfoPresentersRegisterApi
export const infoPresentersRegister = infoPresentersRegisterApi
